'use strict';

const Mn = require('backbone.marionette');
const Template = require('feedback/ui/template/cover.hbs');

const CoverView = Mn.View.extend({
    tagName: 'div',
    template: Template,
    templateContext: function() {
        return {
            isIdea: this.getOption('isIdea'),
            isAnnouncement: this.getOption('isAnnouncement')
        }
    }
});

module.exports = CoverView;




// WEBPACK FOOTER //
// ./feedback/ui/view/cover.js